import React, { memo, useMemo } from 'react';
import { useTheme } from "../../../styles/ThemeContext";

const Divider = () => {
  const { isDarkMode } = useTheme();

  // Generate unique filter ID once using useMemo
  const filterId = useMemo(() => `menu_divider_${Math.random().toString(36).substr(2, 9)}`, []);

  // Get shadow colors for SVG filters based on dark mode
  const shadowColors = isDarkMode ? {
    light: { r: 0.353, g: 0.353, b: 0.353 }, // rgba(90, 90, 90)
    mid: { r: 0.157, g: 0.157, b: 0.157 },   // rgba(40, 40, 40)
    dark: { r: 0.078, g: 0.078, b: 0.078 }   // rgba(20, 20, 20)
  } : {
    light: { r: 1.0, g: 1.0, b: 1.0 },       // rgba(255, 255, 255)
    mid: { r: 0.710, g: 0.710, b: 0.710 },   // rgba(181, 181, 181)
    dark: { r: 0.710, g: 0.710, b: 0.710 }   // rgba(181, 181, 181)
  };

  // Get stroke color based on mode
  const strokeColor = isDarkMode ? '#404040' : '#EEEEEE';

  return (
    <div className="menu-divider">
      <svg xmlns="http://www.w3.org/2000/svg" width="199" height="9" viewBox="0 0 199 9" fill="none">
        <g filter={`url(#${filterId})`}>
          <path d="M4.5 4.5L194.5 4.50002" stroke={strokeColor} strokeWidth="3" strokeLinecap="round"/>
        </g>
        <defs>
          <filter id={filterId} x="0" y="0" width="199" height="9" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="-1" dy="-1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix type="matrix" values={`0 0 0 0 ${shadowColors.dark.r} 0 0 0 0 ${shadowColors.dark.g} 0 0 0 0 ${shadowColors.dark.b} 0 0 0 0.5 0`}/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_43_697"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="1" dy="1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix type="matrix" values={`0 0 0 0 ${shadowColors.light.r} 0 0 0 0 ${shadowColors.light.g} 0 0 0 0 ${shadowColors.light.b} 0 0 0 0.3 0`}/>
            <feBlend mode="normal" in2="effect1_dropShadow_43_697" result="effect2_dropShadow_43_697"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_43_697" result="shape"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="1" dy="1"/>
            <feGaussianBlur stdDeviation="1.5"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values={`0 0 0 0 ${shadowColors.dark.r} 0 0 0 0 ${shadowColors.dark.g} 0 0 0 0 ${shadowColors.dark.b} 0 0 0 0.9 0`}/>
            <feBlend mode="normal" in2="shape" result="effect3_innerShadow_43_697"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="-1" dy="-1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values={`0 0 0 0 ${shadowColors.light.r} 0 0 0 0 ${shadowColors.light.g} 0 0 0 0 ${shadowColors.light.b} 0 0 0 0.9 0`}/>
            <feBlend mode="normal" in2="effect3_innerShadow_43_697" result="effect4_innerShadow_43_697"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="1" dy="-1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values={`0 0 0 0 ${shadowColors.dark.r} 0 0 0 0 ${shadowColors.dark.g} 0 0 0 0 ${shadowColors.dark.b} 0 0 0 0.2 0`}/>
            <feBlend mode="normal" in2="effect4_innerShadow_43_697" result="effect5_innerShadow_43_697"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="-1" dy="1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values={`0 0 0 0 ${shadowColors.dark.r} 0 0 0 0 ${shadowColors.dark.g} 0 0 0 0 ${shadowColors.dark.b} 0 0 0 0.2 0`}/>
            <feBlend mode="normal" in2="effect5_innerShadow_43_697" result="effect6_innerShadow_43_697"/>
          </filter>
        </defs>
      </svg>
    </div>
  );
};

Divider.displayName = 'Divider';

export default memo(Divider);